import { ProfileUser } from '@ordermentum/ui-types';
import { captureException } from './sentry';

const personaFor = (profile: ProfileUser): string => {
  if (profile.isSuperAdmin || profile.isAdmin) return 'Admin';
  if (profile.roles?.suppliers?.length) return 'Supplier';
  return 'Retailer';
};

// JWT goes in context.Intercom because that's what the Segment Intercom destination maps; re-fired per profile fetch to re-issue the 24h token.
export const identifyIntercom = (profile: ProfileUser) => {
  try {
    window.analytics?.identify(
      profile.id,
      {
        email: profile.email,
        firstName: profile.firstName,
        lastName: profile.lastName,
        persona: personaFor(profile),
      },
      { context: { Intercom: { intercom_user_jwt: profile.intercom?.webJwt } } }
    );
  } catch (error) {
    // Identity verification is non-critical — never let an analytics/Intercom failure break app init or profile refetch.
    captureException(error);
  }
};
